import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async indexProject(projectId: Id) {
    return await api(route('api.v1.variation-order-categories.index', projectId), 'get');
  },

  async indexPackage(projectId: Id, packageId: Id) {
    return await api(
      route('api.v1.packages.variation-order-categories.index', {
        project: projectId,
        package: packageId,
      }),
      'get',
    );
  },

  async storeProject(projectId: Id, data: ApiRequests['api.v1.variation-order-categories.store']) {
    return await api(route('api.v1.variation-order-categories.store', projectId), 'post', {
      data,
    });
  },

  async storePackage(
    projectId: Id,
    packageId: Id,
    data: ApiRequests['api.v1.packages.variation-order-categories.store'],
  ) {
    return await api(
      route('api.v1.packages.variation-order-categories.store', {
        project: projectId,
        package: packageId,
      }),
      'post',
      {
        data,
      },
    );
  },

  async update(id: Id, data: ApiRequests['api.v1.variation-order-categories.update']) {
    return await api(route('api.v1.variation-order-categories.update', id), 'patch', {
      data,
    });
  },

  async destroy(id: Id) {
    return await api(route('api.v1.variation-order-categories.destroy', id), 'delete');
  },

  async sort(id: Id, data: ApiRequests['api.v1.variation-order-categories.sort']) {
    return await api(route('api.v1.variation-order-categories.sort', id), 'patch', {
      data,
    });
  },
};
